import { Button as MuiButton } from '@material-ui/core';
import { darken } from '@material-ui/core/styles/colorManipulator';
import { withDefaultPropsAndStyles } from '../utils';
export const PrimaryButton = withDefaultPropsAndStyles('PrimaryButton', MuiButton, {
    defaultProps: {
        color: 'secondary',
        variant: 'contained',
    },
});
export const SecondaryButton = withDefaultPropsAndStyles('SecondaryButton', MuiButton, {
    defaultProps: {
        color: 'secondary',
        variant: 'outlined',
    },
});
export const TertiaryButton = withDefaultPropsAndStyles('TertiaryButton', MuiButton, {
    defaultProps: {
        variant: 'text',
        color: 'primary',
    },
    styles: (theme) => ({
        root: {
            backgroundColor: theme.palette.grey[25],
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: theme.palette.grey[10],
            },
        },
    }),
});
export const AncillaryButton = withDefaultPropsAndStyles('AncillaryButton', MuiButton, {
    defaultProps: {
        color: 'secondary',
        variant: 'text',
    },
});
export const DestructiveButton = withDefaultPropsAndStyles('DestructiveButton', MuiButton, {
    styles: (theme) => ({
        root: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.text.inverse,
            '&:hover': {
                backgroundColor: darken(theme.palette.error.main, 0.15),
            },
        },
    }),
    defaultProps: {
        color: 'primary',
        variant: 'contained',
    },
});
export const CTAButton = withDefaultPropsAndStyles('CTAButton', MuiButton, {
    styles: () => ({
        // NOTE: these empty styles need to exist here in order for the
        // theme-specific overrides to be applied.
        root: {},
        disabled: {},
        containedSecondary: {},
        containedPrimary: {},
    }),
    defaultProps: {
        color: 'inherit',
        variant: 'contained',
        disableElevation: false,
    },
});
//# sourceMappingURL=Button.js.map